export default __webpack_public_path__ + "static/media/VB-icon-red.4292137e.svg";